import * as yup from "yup";

const addPPTInitialValues = {
  file: null,
  comment: "",
  title: "",
  title_html: "",
  body: "",
  body_html: "",
  brand: "",
  thumbnail: null,
  base: null,
  content_to_env_price: [
    {
      env_id: "1",
      price: 0,
    },
  ],
};

const addPPTSchema = yup.object().shape({
  file: yup.mixed().required("Please add a PPT"),
  title: yup.string().trim().required("Please Enter a title"),
  body: yup.string().trim().required("Please Enter a body"),
  brand: yup.string().trim().required("Please select the brand"),
  thumbnail: yup.mixed().required("Please add a Thumbnail"),
  base: yup.mixed().required("Please add a Cover Photo"),
});

const addPDFInitialValues = {
  file: null,
  comment: "",
  title: "",
  title_html: "",
  body: "",
  body_html: "",
  brand: "",
  thumbnail: null,
  base: null,
  speciality: [],
  category: "",
  tags: [],
  brand: "",
  sponsor: "",
  question_code: "",
  base_likes: 0,
  template_id: 0,
  content_to_env_price: [
    {
      env_id: "1",
      price: 0,
    },
  ],
};

const addPDFSchema = yup.object().shape({
  file: yup.mixed().required("Please add a PDF"),
  title: yup.string().trim().required("Please Enter a title"),
  body: yup.string().trim().required("Please Enter a body"),
  brand: yup.string().trim().required("Please select the brand"),
  thumbnail: yup.mixed().required("Please add a Thumbnail"),
  base: yup.mixed().required("Please add a Cover Photo"),
  sponsor: yup.string(),
  question_code: yup.string(),
});

const addFileInitialValues = {
  file: null,
  comment: "",
  title: "",
  title_html: "",
  body: "",
  body_html: "",
  brand: "",
  thumbnail: null,
  base: null,
};

const addFileSchema = yup.object().shape({
  file: yup.mixed().required("Please add a File"),
  title: yup.string().trim().required("Please Enter a title"),
  body: yup.string().trim().required("Please Enter a body"),
  brand: yup.string().trim().required("Please select the brand"),
  thumbnail: yup.mixed().required("Please add a Thumbnail"),
  base: yup.mixed().required("Please add a Cover Photo"),
});

const adddocxInitialValues = {
  file: null,
  comment: "",
  title: "",
  title_html: "",
  body: "",
  body_html: "",
  brand: "",
  thumbnail: null,
  base: null,
};

const adddocxSchema = yup.object().shape({
  file: yup.mixed().required("Please add a DOCX file"),
  title: yup.string().trim().required("Please Enter a title"),
  body: yup.string().trim().required("Please Enter a body"),
  brand: yup.string().trim().required("Please select the brand"),
  thumbnail: yup.mixed().required("Please add a Thumbnail"),
  base: yup.mixed().required("Please add a Cover Photo"),
});

const addzipInitialValues = {
  file: null,
  comment: "",
  title: "",
  title_html: "",
  body: "",
  body_html: "",
  brand: "",
  thumbnail: null,
  base: null,
};

const addzipSchema = yup.object().shape({
  file: yup.mixed().required("Please add a ZIP file"),
  title: yup.string().trim().required("Please Enter a title"),
  body: yup.string().trim().required("Please Enter a body"),
  brand: yup.string().trim().required("Please select the brand"),
  thumbnail: yup.mixed().required("Please add a Thumbnail"),
  base: yup.mixed().required("Please add a Cover Photo"),
});

export {
  addPDFInitialValues,
  addPDFSchema,
  addPPTInitialValues,
  addPPTSchema,
  addFileInitialValues,
  addFileSchema,
  adddocxInitialValues,
  adddocxSchema,
  addzipInitialValues,
  addzipSchema,
};
